import { supabase } from '../supabaseClient'
import { EvaluacionRosaInput, ResultadoRosa } from './rosa'

// ===== Evaluaciones ROSA por local/puesto de trabajo (multi-empresa) =====
// Mismo patrón que gestion-tecnica-reba.ts / reba_assessments: inputs y
// resultado se guardan como jsonb libre. A diferencia de REBA, ROSA ya
// define un único tipo de entrada/resultado por evaluación en src/lib/rosa.ts
// (EvaluacionRosaInput, ResultadoRosa) — se reutilizan directamente, sin
// redefinir un wrapper aquí.

export interface RosaAssessmentRow {
  id: string
  company_id: string
  job_position_id: string | null
  descripcion: string
  inputs: EvaluacionRosaInput
  resultado: ResultadoRosa
  created_by: string | null
  created_at: string
  job_position_name: string | null
}

export interface CreateRosaAssessmentInput {
  companyId: string
  jobPositionId?: string
  descripcion: string
  inputs: EvaluacionRosaInput
  resultado: ResultadoRosa
  createdBy: string | null
}

export async function createRosaAssessment(input: CreateRosaAssessmentInput): Promise<void> {
  const { error } = await supabase.from('rosa_assessments').insert({
    company_id: input.companyId,
    job_position_id: input.jobPositionId ?? null,
    descripcion: input.descripcion,
    inputs: input.inputs,
    resultado: input.resultado,
    created_by: input.createdBy,
  })
  if (error) throw error
}

export async function fetchRosaAssessments(companyId: string): Promise<RosaAssessmentRow[]> {
  if (!companyId) return []
  const { data, error } = await supabase
    .from('rosa_assessments')
    .select('id, company_id, job_position_id, descripcion, inputs, resultado, created_by, created_at, job_positions(name)')
    .eq('company_id', companyId)
    .order('created_at', { ascending: false })
  if (error) throw error
  return (data ?? []).map((r: any) => ({
    id: r.id,
    company_id: r.company_id,
    job_position_id: r.job_position_id,
    descripcion: r.descripcion,
    inputs: r.inputs,
    resultado: r.resultado,
    created_by: r.created_by,
    created_at: r.created_at,
    job_position_name: r.job_positions?.name ?? null,
  })) as RosaAssessmentRow[]
}
